import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Table, TableBody, TableRow, Tooltip, Typography } from '@mui/material';
import type { ControlViolations, BackupStatus } from '@repo/api-gw-sdk';
import type React from 'react';
import { BorderlessTableCell } from '@/components/table/components';
import { BackupStatuses, ControlsSeverity } from '@/data/inventory/data';
import { BackupStatusIcon } from '../backupStatus/backupStatusIcon';
export const ControlIndicator = t0 => {
  const $ = _c(2);
  const {
    backgroundColor
  } = t0;
  let t1;
  if ($[0] !== backgroundColor) {
    t1 = <Box component="span" className="rounded-full w-[8px] h-[8px] m-[8px] inline-block" sx={{
      backgroundColor,
      flexShrink: 0,
      minWidth: "8px",
      minHeight: "8px"
    }} />;
    $[0] = backgroundColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const controlKeysPriorities: (keyof ControlViolations)[] = ['high', 'medium', 'low', 'muted'];
export const ControlsColumnIndicators = t0 => {
  const $ = _c(21);
  const {
    controlViolations,
    backupStatus
  } = t0;
  const data = BackupStatuses[backupStatus];
  if (!data) {
    return null;
  }
  if (!controlViolations) {
    let t1;
    if ($[0] !== backupStatus) {
      t1 = <BackupStatusIcon backupStatus={backupStatus} />;
      $[0] = backupStatus;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== data.title || $[3] !== t1) {
      t2 = <Tooltip title={data.title}>{t1}</Tooltip>;
      $[2] = data.title;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "var(--mui-palette-Tooltip-text)"
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== data.title) {
    t2 = <Typography className="mb-[8px]" sx={t1}>{data.title}</Typography>;
    $[6] = data.title;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== controlViolations) {
    t3 = controlKeysPriorities.map(priority => {
      const amount = controlViolations[priority];
      return !!amount && <TableRow key={priority} className="mt-[4px] py-[2px]"><BorderlessTableCell><ControlIndicator backgroundColor={ControlsSeverity[priority].color} /></BorderlessTableCell><BorderlessTableCell><Typography className="ml-[8px]" sx={{
            color: "var(--mui-palette-Tooltip-text)"
          }}>{amount}</Typography></BorderlessTableCell><BorderlessTableCell><Typography className="ml-[8px]" sx={{
            color: "var(--mui-palette-Tooltip-text)"
          }}>{ControlsSeverity[priority].title}</Typography></BorderlessTableCell></TableRow>;
    });
    $[8] = controlViolations;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <Table><TableBody>{t3}</TableBody></Table>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <Stack>{t2}{t4}</Stack>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      tooltip: {
        sx: {
          width: "170px",
          padding: "16px"
        }
      }
    };
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== backupStatus) {
    t7 = <BackupStatusIcon backupStatus={backupStatus} />;
    $[16] = backupStatus;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <Tooltip disableInteractive={false} title={t5} className="ml-[8px]" slotProps={t6}>{t7}</Tooltip>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};